"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
var _Dashboard = _interopRequireDefault(require("Components/Lists/Dashboard"));
var _ChatRow = _interopRequireDefault(require("../../Components/Lists/Rows/ChatRow"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChatsDashboardPage = props => {
  const header = [{
    name: 'pratician',
    label: 'Praticien '
  }, {
    name: 'related_project',
    label: 'À propos du dossier'
  }, {
    name: 'updated_at',
    label: 'Date du dernier message'
  }];
  if (app.state.session.user.roles.includes("pratician")) {
    delete header[0];
  }
  const fields = header.map(infos => infos.name);
  let filters = {};
  return /*#__PURE__*/_react.default.createElement(_Back.default, (0, _extends2.default)({
    page_title: "Les messages "
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "o-content dashboard-page"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-right"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    href: (0, _Routing.URL)('NewChat'),
    className: (0, _bemit.default)('c-flat-btn', ['primary'])
  }, "Envoyer un message"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-table u-margin-bottom-25 o-content",
    style: {
      overflow: 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Chat",
    url: (0, _Routing.action)('getAllMessages'),
    header: header,
    fields: fields,
    component: _ChatRow.default,
    "items-per-page": 30,
    filters: filters,
    order: "desc",
    "order-by": "updated_at"
  }))));
};
var _default = exports.default = ChatsDashboardPage;
